import React from 'react';
import { FaLinkedin, FaTwitter, FaEnvelope, FaCalendarAlt } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Footer = ({ onOpenContact }) => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const handleBookDemo = () => {
    window.open('https://calendly.com/contact-apexlegalsystems/30min', '_blank');
  };

  const scrollToSection = (id) => {
    if (location.pathname === '/') {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <footer className="bg-slate-900 border-t border-slate-800 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="text-2xl font-bold mb-4">
              <span className="text-white">APEX</span>
              <span className="gradient-text"> LEGAL SYSTEMS</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Helping PI law firms capture 100% of their leads 24/7 with AI-powered intake automation.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">
                <FaLinkedin className="text-2xl" />
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">
                <FaTwitter className="text-2xl" />
              </a>
              <button 
                onClick={onOpenContact}
                className="text-gray-400 hover:text-emerald-400 transition-colors"
                data-testid="footer-contact-button"
              >
                <FaEnvelope className="text-2xl" />
              </button>
              <button onClick={handleBookDemo} className="text-gray-400 hover:text-emerald-400 transition-colors">
                <FaCalendarAlt className="text-2xl" />
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('solution')} className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Features
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('how-it-works')} className="text-gray-400 hover:text-emerald-400 transition-colors">
                  How It Works
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-gray-400 hover:text-emerald-400 transition-colors">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={onOpenContact}
                  className="text-gray-400 hover:text-emerald-400 transition-colors"
                >
                  contact@apexlegalsystems.com
                </button>
              </li>
              <li>
                <button onClick={handleBookDemo} className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Book Discovery Call
                </button>
              </li>
              <li>
                <a href="https://calendly.com/contact-apexlegalsystems/30min" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Schedule Call
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm mb-4 md:mb-0">
              © {currentYear} Apex Legal Systems LLC. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacy" className="text-gray-500 hover:text-emerald-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-500 hover:text-emerald-400 transition-colors">
                Terms of Service
              </Link>
              <button 
                onClick={onOpenContact}
                className="text-gray-500 hover:text-emerald-400 transition-colors"
              >
                HIPAA Compliance
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
